/** SK translations for Les Aiguilles Blanches */
const sk: Record<string, string> = {
  subtitle: "Simulátor rolby",
  startGame: "Začať hru",
  resumeGame: "Pokračovať",
  newGame: "Nová hra",
  // UNUSED continue: "Pokračovať",
  settings: "Nastavenia",
  controls: "Ovládanie",
  changelog: "Novinky",
  howToPlay: "Ako hrať",
  fullscreen: "Celá obrazovka",
  fullscreenHint: "Stlač F pre celú obrazovku",
  exitFullscreen: "Ukončiť celú obrazovku",
  back: "Späť",
  backToGame: "Späť do hry",
  // UNUSED loading: "Načítavanie...",
  inputKeyboard: "✓ Klávesnica nájdená",
  inputKeyboardOff: "✗ Žiadna klávesnica",
  inputTouch: "✓ Dotykový displej nájdený",
  inputTouchOff: "✗ Dotykový displej nenájdený",
  inputGamepad: "✓ Gamepad pripojený",
  inputGamepadOff: "✗ Žiadny gamepad",
  updateAvailable: "Nová verzia k dispozícii — ťukni pre obnovenie",
  madeIn: "Vyrobené s ❄️ v Savojsku",
  feedback: "Odoslať spätnú väzbu",
  on: "✓ ZAP",
  off: "✗ VYP",
  zoneClosed: "🚫 ZÓNA ZATVORENÁ",

  // Settings
  language: "Jazyk",
  accessibility: "Prístupnosť",
  highContrast: "Vysoký kontrast",
  reducedMotion: "Obmedzený pohyb",
  showFps: "Zobraziť FPS",
  showDebug: "Ladenie",
  skiStyle: "Štýl",
  skiTricks: "Triky",
  skiBestCombo: "Najlepšie kombo",
  quitGame: "Ukončiť hru",
  display: "Zobrazenie",
  displayWindowed: "Okno",
  displayFullscreen: "Celá obrazovka",
  displayBorderless: "Bez rámčeka",
  colorblindMode: "Farbosleposť",
  none: "Žiadne",
  deuteranopia: "Deutan.",
  protanopia: "Protan.",
  tritanopia: "Tritan.",
  // UNUSED move: "Pohyb",
  moveUp: "Hore",
  moveDown: "Dole",
  moveLeft: "Vľavo",
  moveRight: "Vpravo",
  groom: "Upraviť",
  winch: "Naviják",
  pause: "Pauza",
  keyboard: "Klávesnica",
  clickToRebind: "Klikni pre zmenu",
  pressKey: "Stlač klávesu...",
  pressGamepadButton: "Stlač tlačidlo gamepadu...",
  noGamepad: "Žiadny gamepad nepripojený",
  gamepadButtons: "Gamepad",
  saved: "Uložené!",
  resetControls: "Obnoviť všetko",
  controlsReset: "Ovládanie obnovené!",
  movementSensitivity: "Citlivosť",
  keyboardLayout: "Rozloženie",
  customBindings: "Vlastné",
  // UNUSED gamepadSupported: "Gamepad OK",
  touch: "Dotyk",
  // UNUSED touchSupported: "Dotyk OK",
  noGamepadConnected: "Žiadny gamepad pripojený",
  gamepadDiagnostic: "Test ovládača",
  connectGamepadDiag: "Pripoj ovládač na testovanie",
  gamepadDiagButtons: "Tlačidlá",
  gamepadDiagSticks: "Páčky",
  gamepadDiagTriggers: "Spúšte",

  // Audio
  audio: "Zvuk",
  masterVolume: "Hlavná hlasitosť",
  musicVolume: "Hudba",
  sfxVolume: "Zvukové efekty",
  engineVolume: "Motor",
  voiceVolume: "Hlasy",
  ambienceVolume: "Prostredie",
  mute: "Stlmiť",

  backgroundAudio: "Zvuk na pozadí",
  // Gameplay
  bonus: "Bonus",
  skiMode: "Režim zjazdu",
  ski: "Lyže",
  snowboard: "Snowboard",
  random: "Náhodný",
  skiIt: "Lyžovať!",
  rideIt: "Na dosku!",
  skiAgain: "Ešte raz!",
  rideAgain: "Ešte raz!",
  skiRunSpeed: "Rýchlosť",
  skiRunTime: "Čas",
  skiRunGates: "Brány",

  // How to Play hints
  howToPlayMove: "{keys} alebo šípky pre pohyb",
  howToPlayMoveTouch: "Použi virtuálny D-pad",
  howToPlayMoveGamepad: "Ľavá páčka alebo D-pad pre pohyb",
  howToPlayMoveHybrid: "{keys}/šípky alebo dotykový D-pad",
  howToPlayGroom: "{groomKey} pre úpravu snehu",
  howToPlayGroomTouch: "Drž tlačidlo úpravy",
  howToPlayGroomGamepad: "pre úpravu snehu",
  howToPlayGroomHybrid: "{groomKey} alebo drž tlačidlo úpravy",
  howToPlayFuel: "Sleduj palivo a výdrž!",
  howToPlayWinch: "{winchKey} pri kotve pre naviják",
  howToPlayWinchTouch: "Drž tlačidlo navijáka pri kotve",
  howToPlayWinchGamepad: "pri kotve pre naviják",
  howToPlayWinchHybrid: "{winchKey} alebo drž tlačidlo navijáka pri kotve",

  // Winch
  winchSnapped: "💥 Kábel sa pretrhol!",
  winchAttached: "🔗 Naviják pripojený! Drž {winchKey} pre pomoc.",
  winchActive: "NAVIJÁK",
  // UNUSED winchHint: "Stlač {winchKey} pri kotviacom stĺpiku pre naviják",
  // UNUSED winchHintTouch: "Drž 🔗 pre naviják",
  // UNUSED accessPath: "Servisná cesta",
  // UNUSED toPiste: "Na zjazdovku",

  // Taunts - Cliff falls
  tauntCliff1: "9 ton do rokliny. Poisťovňa bude nadšená.",
  tauntCliff2: "Jean-Pierre hovoril 'nie príliš blízko k okraju!' Pamätáš?",
  tauntCliff3: "Horská služba sa zlaňuje s lanami. Zase.",
  tauntCliff4: "Marie ruší tvoju rezerváciu na raclette na dnešný večer.",
  tauntCliff5: "Thierry už počíta náklady na opravu...",

  // Taunts - Fuel empty
  tauntFuel1: "Ukazovateľ bol na červenej 10 minút. Na čo si sa pozeral?",
  tauntFuel2: "Émilie napísala 'NATANKOVAŤ' veľkými písmenami na tabuľu.",
  tauntFuel3: "Aj nafta má svoje limity. Ty zrejme tiež.",
  tauntFuel4: "Jean-Pierre vzdychá. Posiela Thierryho s kanistrom.",
  tauntFuel5: "Slnko vychádza. Zjazdovka nie je upravená. Lyžiari prichádzajú.",

  // Taunts - Time limit
  tauntTime1: "Prvý vlek za 3... 2... 1... Nestihol si.",
  tauntTime2: "Lyžiari objavujú tvoju zjazdovku. Hrboľatá. Ľadová. Nádhera.",
  tauntTime3: "Jean-Pierre sa pozerá na hodinky, potom na teba, potom na hodinky.",
  tauntTime4: "FIS sa pýta, prečo je slalom na kaši.",
  tauntTime5: "Počuješ inštruktorov, ako klientom vysvetľujú, prečo to 'nie je ich chyba'.",

  // UNUSED paused: "Pozastavené",
  resume: "Pokračovať",
  quitToMenu: "Odísť do menu",
  levelComplete: "Trať dokončená!",
  levelFailed: "Trať neúspešná",
  tryAgain: "Skúsiť znova",
  coverage: "Pokrytie",
  time: "Čas",
  // UNUSED rating: "Hodnotenie",
  nextLevel: "Ďalšia trať",
  // UNUSED replay: "Prehrať znova",
  // UNUSED pressContinue: "Stlač medzerník alebo ťukni pre pokračovanie",
  pauseTitle: "⏸️ Pozastavené",
  restart: "Reštartovať",
  skipRun: "Preskočiť zjazd",
  newRun: "Nová zjazdovka",
  quit: "Odísť",
  menu: "Menu",
  levelSelect: "Výber trate",
  locked: "Zatvorená",
   completeToUnlock: "Dokonči {name} na odomknutie",
  // UNUSED target: "Cieľ",
  tutorial: "Lyžiarska škola",
  timeUsed: "Spotrebovaný čas",
  excellent: "Výborne!",
  good: "Dobrá práca!",
  passed: "Splnené",
  bonusFuel: "Spotreba paliva",
  bonusFlawless: "Na prvý pokus",
  bonusSpeed: "Čas",
  bonusWinch: "Použitia navijáku",
  bonusExplore: "Preskúmané cesty",
  bonusPrecision: "Kvalita úpravy",
  retry: "Opakovať",
  gameComplete: "Hra dokončená!",
  viewCredits: "Zobraziť titulky",
  creditsTitle: "Gratulujeme!",
  creditsSubtitle: "Ovládol si Les Aiguilles Blanches",
  creditsCreatedBy: "Vytvoril",
  creditsDevelopedWith: "Vyvinuté s",
  creditsArtDirection: "Umelecká réžia",
  creditsRetroInspiration: "Pocta retro klasikám ako SkiFree",
  creditsInspiredBy: "Inšpirované",
  creditsGroomers: "Ratrakári zo Savoie",
  creditsDedication: "Pre nočné posádky, ktoré pripravujú svahy, kým spíme",
  creditsThanks: "Vďaka za hru!",
  creditsSeeYou: "Vidíme sa na svahoch!",
  creditsLine: "Poď, chlapče. Slnko vychádza. Hora je pripravená.",
  playAgain: "Hrať znova",
  skipCredits: "Stlač klávesu pre preskočenie",

  // Tutorial
  tutorialName: "Návod - Prvé kroky",
  tutorialTask: "Nauč sa základy úpravy",
  prologueLine: "4 ráno. Hora je tvoja. Do práce.",
  prologueSkip: "Stlač pre pokračovanie",
  tutorialIntro: "Vitaj v Les Aiguilles Blanches!",
  skipTutorial: "⏭️ Preskakujem návod… Ťukni pre prehranie.",
  skipTutorialGamepad: "⏭️ Preskakujem návod… Stlač tlačidlo pre prehranie.",
  tutorialWelcome: "🏔️ Jean-Pierre, hlavný rolbár. Choď po zjazdovke — použi {keys} alebo ↑↓←→.",
  tutorialWelcomeTouch: "🏔️ Jean-Pierre, hlavný rolbár. Choď po zjazdovke — použi D-pad vľavo.",
  tutorialWelcomeGamepad: "🏔️ Jean-Pierre, hlavný rolbár. Choď po zjazdovke — použi ľavú páčku alebo D-pad.",
  // UNUSED     tutorialControls: "🎮 Pre pohyb frézy použi {keys} alebo šípky ↑↓←→.",
  // UNUSED     tutorialControlsTouch: "🎮 Pre pohyb frézy použi D-pad ◀▲▼▶ vľavo.",
  // UNUSED     tutorialControlsGamepad: "🎮 Pre pohyb frézy použi ľavú páčku alebo D-pad.",
  // UNUSED     tutorialMove: "➡️ Tak do toho! Pohybuj sa po zjazdovke — všetok biely sneh potrebuje úpravu.",
  // UNUSED     tutorialGroomIntro: "✅ Pekné! Teraz sa naučíme upravovať.",
  tutorialGroomAction: "❄️ Drž {groomKey} počas jazdy pre úpravu snehu. Sneh sa vyrovná.",
  tutorialGroomActionTouch: "❄️ Drž tlačidlo úpravy vpravo počas jazdy pre úpravu snehu.",
  tutorialGroomActionGamepad: "❄️ Drž {groomKey} počas jazdy pre úpravu snehu. Sneh sa vyrovná.",
  tutorialGroomGoal: "📊 Správne! Uprav aspoň 60% pred otvorením. Lyžiari prichádzajú!",
  // UNUSED   tutorialCoverage: "📊 Vidíš? Sneh je hladší! Pokračuj v úprave zjazdovky.",
  // UNUSED   tutorialHUD: "📈 Sleduj panel hore: červená je palivo, zelená výdrž, biela pokrytie. Čas beží!",
  // UNUSED   tutorialGoal: "🎯 Musíš upraviť aspoň 60% zjazdovky pred otvorením. Lyžiari prichádzajú!",
  // UNUSED tutorialFuel: "⛽ Pozor — jazda spotrebúva palivo. Na misiách stav na čerpacej stanici.",
  tutorialComplete: "🏆 Výborne! Ovládol si základy. Pripravený na prvú misiu na zelenej zjazdovke?",

  level_marmottesName: "Zelená zjazdovka - Les Marmottes",
  level_marmottesTask: "Uprav zjazdovku pre začiatočníkov",
  level_chamoisName: "Modrá zjazdovka - Le Chamois",
  level_chamoisTask: "Uprav efektívne pred otvorením",
  level_airZoneName: "Snowpark - Air Zone",
  level_airZoneTask: "Priprav freestyle prvky",
  level_aigleName: "Červená zjazdovka - L'Aigle",
  level_aigleTask: "Uprav strmý terén, sleduj palivo",
  level_glacierName: "Červená zjazdovka - Le Glacier",
  level_glacierTask: "Nauč sa používať naviják na strmých svahoch",
  level_tubeName: "Half-pipe - Le Tube",
  level_tubeTask: "Udržuj half-pipe pre preteky",
  level_verticaleName: "Čierna zjazdovka - La Verticale",
  level_verticaleTask: "Nočná operácia s navijákom",
  level_colDangereuxName: "Lavínová zóna - Col Dangereux",
  level_colDangereuxTask: "Priprav vysoko rizikovú zónu",
  level_tempeteName: "Búrka - Obnova",
  level_tempeteTask: "Vyčisti zjazdovky po búrke",
  level_coupeDesAiguillesName: "Coupe des Aiguilles - Finále FIS",
  level_coupeDesAiguillesTask: "Priprav všetky zjazdovky na preteky",

  // Hazards
  cliffFall: "⚠️ POZOR! Spadol si z útesu! Misia zlyhala.",
  fuelEmpty: "⛽ BEZ PALIVA! Ani kvapka nafty...",
  // UNUSED avalancheZone: "LAVÍNOVÁ ZÓNA",
  riskLevelHigh: "VYSOKÉ",
  avalancheWarning: "⚠️ NEBEZPEČENSTVO! Snehová pokrývka je nestabilná! Opusti zónu!",
  avalancheTrigger: "🏔️💨 LAVÍNA SPUSTENÁ! Žiadny únik!",
  steepWarning: "⚠️ STRMÝ SVAH! Použi naviják ({winchKey}) alebo skĺzneš!",
  steepWarningNoWinch: "⚠️ STRMÝ SVAH! Spomaľ a použi servisné cesty na obídenie!",
  tumble: "🔄 PREVRÁTENIE! Fréza sa prevrátila na svahu!",

  // Taunts - Tumble
  tauntTumble1: "Naviják nie je na ozdobu. Je pre svahy ako je tento.",
  tauntTumble2: "Thierry hľadí na škodu. Nehovorí nič. To je horšie.",
  tauntTumble3: "Jean-Pierre ti ukázal, ako kotviť. Spal si?",
  tauntTumble4: "PistenBully stojí 400 000 €. Teda, stál.",
  tauntTumble5: "Svah vyzeral zvládnuteľne? Fréza nesúhlasila.",
  featureDestroyedKicker: 'Prešiel si cez parkový prvok! Kicker je zničený.',
  featureDestroyedRail: 'Prešiel si cez parkový prvok! Rail je zničený.',
  tauntFeature1: 'Ten prvok stavali tri hodiny. Ty si ho zrovnal za tri sekundy.',
  tauntFeature2: 'Émilie si s tebou pohovorí o tom parkovom prvku.',
  tauntFeature3: 'Parková posádka práve videla, ako ničíš ich dielo.',
  tauntFeature4: 'Prvky sú pre lyžiarov, nie pre rolby. Obíď ich!',
  tauntFeature5: 'O jeden prvok menej na zajtrajšie preteky.',
  bonusPipeMastery: 'Zvládnutie halfpipe',

  // Taunts - Avalanche
  tauntAvalanche1: "Hora málokedy odpúšťa. Tentoraz neodpustila.",
  tauntAvalanche2: "Météo France hlásilo stupeň rizika 4. Čítal si to?",
  tauntAvalanche3: "Horská služba nájde rolbu na jar. Možno.",
  tauntAvalanche4: "Marie počuje poplach v rádiu. Už vie, že si to ty.",
  tauntAvalanche5: "Horská služba zabezpečila ten sektor. Ty si ho odbezpečil.",

  // Taunts - Ski wipeout (fun, self-deprecating)
  tauntSkiWipeout1: "Klasický pád. Výstroj všade, dôstojnosť nikde.",
  tauntSkiWipeout2: "Útesu bolo jedno, akú máš techniku.",
  tauntSkiWipeout3: "Horská služba sa už smeje. Videli všetko.",
  tauntSkiWipeout4: "To sa stane, keď lyžuješ na vlastnej zjazdovke.",
  tauntSkiWipeout5: "Aj kamzíky sa pri tom dopade zaškierili.",

  jeanPierreIntro: "Dobrá práca v tutoriáli. Teraz to bude naostro — zelená zjazdovka, s časom a palivom na starosti.",
  level_marmottesMid: "Vidíš tú žiaru na hrebeňoch? Prvé svitanie. Najlepšia časť tejto práce — len ty, stroj a hora, čo sa prebúdza.",
  level_chamoisIntro: "Ahoj, som Émilie — JP ťa posiela na modrú. Ukáž, že zvládneš viac než len samety na zelenej.",
  level_airZoneIntro: "Snowpark je MÔJ rajón — pripravíme im niečo šialené! Každý modul musí sedieť, jazdci na nás počítajú.",
  level_aigleIntro: "L'Aigle je vážna vec. Sleduj palivo. Po servisných cestách sa vrátiš hore — hľadaj žlto-čierne stĺpiky.",
  level_glacierIntro: "Ahoj, ja som Thierry — šéf bezpečnosti. Le Glacier je strmý. Skontroloval som každú kotvu. Stlač {winchKey} pri stĺpiku pre pripojenie navijáku — a prosím ťa, nepúšťaj.",
  level_glacierIntroTouch: "Ahoj, ja som Thierry — šéf bezpečnosti. Le Glacier je strmý. Skontroloval som každú kotvu. Ťukni na tlačidlo navijáku pri stĺpiku — a prosím ťa, nepúšťaj.",
  level_tubeIntro: "Zajtra je contest na Tube! Chcem čisté steny, ostrý okraj a nula hrboľov.",
  level_verticaleIntro: "Nočná akcia na La Verticale: strmý svah, nebezpečné okraje. Naviják je povinný — použi 3 ukotvenia a drž sa osi.",
  level_colDangereuxIntro: "Vysoké lavínové riziko na priesmyku — pracujeme podľa protokolu lavínového zabezpečenia. Drž sa od zaťažených zón a rešpektuj hranice.",
  level_tempeteIntro: "Búrka prešla. Daj si vin chaud — bude to chvíľu trvať!",
  level_coupeDesAiguillesIntro: "Toto je veľká noc. FIS kontroluje zajtra. Každá zjazdovka musí byť perfektná — ukáž, čo si sa naučil.",
  marieWelcome: "Príď sa ohriať k Chez Marie. Dobrá tartiflette!",
  marieIntro: "Ahoj! Som Marie, vediem reštauráciu hore pri zjazdovke. Stav sa kedy chceš — teplé jedlo tu robí zázraky!",

  // Changelog
  changelog_20260219_date: "19. februára 2026",
  changelog_20260219: "🎬 Prológ pre nových hráčov\n📖 Zjednodušený tutoriál\n🌦️ Náhodné počasie v menu\n🔗 Zdieľateľné denné zjazdy\n🎥 Filmové titulky",
  changelog_20260222_date: "22. februára 2026",
  changelog_20260222: "🚩 Vyváženie slalomových bránok\n💬 Tlačidlo spätnej väzby",
  changelog_20260223_date: "23. februára 2026",
  changelog_20260223: "📲 Nainštaluj si hru na zariadenie a hraj offline",
  changelog_20260220_date: "20. februára 2026",
  changelog_20260220: "🗺️ Mapa tratí\n🎿 Lyžiarska terminológia",
  changelog_20260217_date: "17. februára 2026",
  changelog_20260217: "🏔️ Sedem tvarov zjazdoviek\n🎯 Rozmanitosť generovania\n⚡ Plynulejší zjazd",
  changelog_20260216_date: "16. februára 2026",
  changelog_20260216: "🎲 Dnešné zjazdovky",
  changelog_20260215_date: "15. februára 2026",
  changelog_20260215: "⚡ Prepracovanie nočného renderu\n📱 Dotykové tlačidlá v lyžovaní\n⌨️ Detekcia rozloženia klávesnice",
  changelog_20260214_date: "14. februára 2026",
  changelog_20260214: "🎪 Bodovanie trikov & kombá\n🏂 Zjazdový postoj & fyzika halfpipe\n👁️ Lepší kontrast zjazdoviek\n📱 Automatická úprava pri navijaku (dotyk)\n♿ Režim vysokého kontrastu",
  changelog_20260213_date: "13. februára 2026",
  changelog_20260213: "🚩 Slalomové brány\n🏔️ Skoky na lyžiach\n⚡ Vylepšený výkon\n🎹 Nočná klavírna hudba\n🔊 Hlasitosť motora nastaviteľná",
  changelog_20260212_date: "12. februára 2026",
  changelog_20260212: "📋 Mapa tratí\n🔗 Pretrhnuteľné lano navijaku\n🕹️ Diagnostika ovládača\n🍽️ Jedlá od Marie\n❄️ Expozícia mrazu",
  changelog_20260211_date: "11. februára 2026",
changelog_20260211: "⛷️ Zjazd na lyžiach po úprave\n🎯 Kvalita úpravy\n🏔️ Farebne rozlíšené strmé zóny\n🏗️ Park a triky",
  changelog_20260210_date: "10. februára 2026",
  changelog_20260210: "🎵 Hudba a zvukové efekty\n🔈 Nastavenia hlasitosti\n⏱️ Automaticky kalibrované časy\n⏭️ Preskočiť tutoriál\n🏔️ Prepracované lavínové zóny",
  changelog_20260209_date: "9. februára 2026",
  changelog_20260209: "🏔️ Alpské obrazovky výhier/prehier\n❄️ Snehová akumulácia pri búrke\n🏆 Bonus za bezchybnosť\n🔊 Zvuky počasia a zvierat",
  changelog_20260208_date: "8. februára 2026",
  changelog_20260208: "📊 Prepracovaný panel\n🏔️ Le Glacier a Coupe des Aiguilles\n🦅 Alpská zver\n🎨 Portréty postáv\n🎮 Navigácia klávesnicou a gamepadom",
  changelog_20260207_date: "7. februára 2026",
  changelog_20260207: "🎨 Retro UI\n🎯 Bonusové ciele\n🕹️ Premapovanie gamepadu\n🎮 Navigácia v menu gamepadom",
  changelog_20260206_date: "6. februára 2026",
  changelog_20260206: "🛤️ Zjazdné servisné cesty\n🕹️ Virtuálny joystick\n🌍 5 jazykov",
  changelog_20260205_date: "5. februára 2026",
  changelog_20260205: "🏔️ Skalné útesy\n🌙 Nočné svetlá\n🔗 Mechanika navijáku\n⌨️ Navigácia klávesnicou",
  changelog_20260204_date: "4. februára 2026",
  changelog_20260204: "🎮 Podpora gamepadu\n📱 Dotykové ovládanie\n💪 Výdrž\n💾 Uloženie postupu\n♿ Prístupnosť",
  changelog_20260203_date: "3. februára 2026",
  changelog_20260203: "🚜 Spustenie: 9 tratí, lyžiarska škola\n❄️ Úprava, palivo, lavíny\n🏆 Titulky a postup",
  // Key names
  key_space: "MEDZERNÍK",
  key_shift: "SHIFT",
  key_ctrl: "CTRL",
  key_alt: "ALT",
  key_enter: "ENTER",
  key_tab: "TAB",
  key_esc: "ESC",
  key_del: "DEL",
  dailyRuns: "Dnešné zjazdovky",
  dailyRuns_dailyShift: "Denná zmena",
  dailyRuns_randomRun: "Náhodná jazda",
  dailyRuns_rank: "Hodnotenie",
  dailyRuns_seed: "Kód",
  // UNUSED   dailyRuns_start: "Začať kontrakt",
  dailyRuns_locked: "Dokonči všetky trate na odomknutie",
  dailyRuns_lockedShared: "Dokonči všetky trate na odomknutie denných behov a zahranie tejto zdieľanej zjazdovky",
  // UNUSED   dailyRun_levelName: "Kontrakt",
  dailyRun_levelTask: "Uprav zjazdovku na cieľové pokrytie",
  dailyRuns_briefing: "Zadanie",
  dailyRuns_target: "Cieľ",
  dailyRuns_timeLimit: "Čas",
  dailyRuns_weather_clear: "Jasná obloha",
  dailyRuns_weather_light_snow: "Mierne sneženie",
  dailyRuns_weather_storm: "Búrkové podmienky",
  dailyRuns_night: "Nočná zmena",
  dailyRuns_day: "Denná zmena",
  rank_green: "Zelená",
  rank_blue: "Modrá",
  rank_red: "Červená",
  rank_black: "Čierna",
  rank_park: "Park",
  share: "Zdieľať",
  copied: "Odkaz skopírovaný!",
  playSharedSeed: "Zdieľaný beh",
  dailyRunBriefingJP: "Zjazdovka musí byť pripravená pred otvorením vlekov. Do toho.",
  dailyRunBriefingThierry: "Dávaj si pozor — strmé úseky a nestabilný sneh. Buď ostražitý.",
  dailyRunBriefingMarie: "Dnes v noci bude poriadna zima. Zastav sa v reštaurácii zahriať, keby bolo treba.",
  dailyRunBriefingEmilie: "Ďalšia zjazdovka. Skús prekonať môj čas!"
};

export default sk;
